module.exports = __webpack_public_path__ + "img/tote-bag.a17860e9.jpg";